import React from 'react';

import Menu from '../../components/Menu';
import Layout from '../../pages/_layouts/default';

const Dashboard = () =>  {

  return (
    <Layout>
      <Menu />
    </Layout>
  );
}

export default Dashboard;